import { observer } from 'mobx-react';
import { BatchFileImportPage } from '@product-framework/components/BatchFileImportPage';
import { IconLibrary } from '@product-framework/index';
import { listSchema, searchSchema } from '../../schemas';
import validationSchema from './validations';
import { createApis, statusOptions } from './config';
import {
  download,
  preview,
  createdDateTime,
  createdByUser,
  fileName,
  fileSize,
  batchStatus,
  numberOfRecords,
} from './accessorFunctions';

const STORE_NAME = 'ClaimPaymentImportList';

function ClaimPaymentImportList() {
  return (
    <BatchFileImportPage
      storeName={STORE_NAME}
      accept=".json,application/json"
      breadcrumb={{
        id: 'LIST_CLAIM_PAYMENT_IMPORTS',
        defaultMessage: 'List Claim Payment Imports',
        icon: IconLibrary.ClaimPaymentExports,
      }}
      listHeading={{
        id: 'CLAIM_PAYMENT_IMPORTS',
        defaultMessage: 'Claim Payment Imports',
      }}
      searchHeading={{
        id: 'SEARCH_CLAIM_PAYMENT_IMPORTS',
        defaultMessage: 'Search Claim Payment Imports',
      }}
      listSchema={listSchema}
      accessorFunctions={{
        download,
        preview,
        createdDateTime,
        createdByUser,
        fileName,
        fileSize,
        batchStatus,
        numberOfRecords,
      }}
      searchFields={searchSchema}
      searchValidationSchema={validationSchema}
      statusOptions={statusOptions}
      apis={createApis()}
    />
  );
}

export default observer(ClaimPaymentImportList);
